var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mar-t-5f"},[_c('buildList',{attrs:{"houseingRes":_vm.houseingRes},on:{"oneBuild":_vm.oneBuild}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }